const moduleLabels = {
  USER: "Manage User",
  ROLE: "Manage Roles",
  INVESTOR: "Manage Investors",
  WEALTH_PARTNER: "Manage Wealth Partners",
  ICD: "Manage ICD's",
  BOND: "Manage Bonds",
  BOND_REQUEST: "Manage Bonds Request",
  PERMISSION: "Manage Permission",
  PLATFORM_MANAGER: "Manage Platform Manager",
  REIT: "Manage REIT",
  REPORT: "Manage Reports",
  BLOG: "Manage Blogs",
  FAQ: "Manage FAQs",
  VIDEO: "Manage Videos",
  DOC: "Manage Sample Documents",
  ABOUT_US: "Manage About Prachay",
  ABOUT_ICD: "Manage About ICDs",
  FOUNDER_MESSAGE: "Manage Founder's Message",
  HELP: "Manage Help Requests",
}

export { moduleLabels }
